module.exports = __webpack_public_path__ + "static/media/icon_properties.62a05cf2.svg";